export const CountryList = [
  "Australia New South Wales",
  "Australia Queensland",
  "Australia Tasmania",
  "Australia Victoria",
  "Australia Western Australia",
  "Brazil Central-West",
  "Brazil North",
  "Brazil Northeast",
  "Brazil South",
  "Brazil Southeast",
  "Finland",
  "France",
  "Germany",
  "India Eastern Region",
  "India Northeastern Region",
  "India Northern Region",
  "India Southern Region",
  "India Western Region",
  "Italy C.North",
  "Italy C. South",
  "Italy Calabria",
  "Italy North",
  "Italy Sardinia",
  "Italy Sicily",
  "Italy South",
  "Netherlands",
  "New Zealand - North",
  "New Zealand - South",
  "Poland",
  "Portugal",
  "Romania",
  "Singapore",
  "Spain",
  "Sweden 1",
  "Sweden 2",
  "Sweden 3",
  "Sweden 4",
  "Turkey",
  "U.S. CAISO",
  "U.S. ERCOT",
  "U.S. ISO-NE",
  "U.S. MISO",
  "U.S. Northwest",
  "U.S. NYISO",
  "U.S. PJM",
  "U.S. Southeast",
  "U.S. Southwest",
  "U.S. SPP",
  "United Kingdom",
  "NZ - OTA2201 - Otahuhu",
  "NZ - WKM2201 - Whakamaru",
  "NZ - RDF2201 - Redclyffe",
  "NZ - SFD2201 - Stratford",
  "NZ - HAY2201 - Haywards",
  "NZ - KIK2201 - Kikiwa",
  "NZ - ISL2201 - Islington",
  "NZ - BEN2201 - Benmore",
  "NZ - INV2201 - Invercargill",
  "NZ - ABY0111 - Albury",
  "NZ - ADD0111 - Addington",
  "NZ - ADD0661 - Addington",
  "NZ - AHA0111 - Arahura",
  "NZ - ALB0331 - Albany",
  "NZ - ALB1101 - Albany",
  "NZ - ANA0111 - Arohena",
  "NZ - APS0111 - Arthur's Pass",
  "NZ - ARA2201 - Aratiatia",
  "NZ - ARG1101 - Argyle",
  "NZ - ARI0501 - Arapuni",
  "NZ - ARI1101 - Arapuni",
  "NZ - ARI1102 - Arapuni",
  "NZ - ASB0331 - Ashburton",
  "NZ - ASB0661 - Ashburton",
  "NZ - ASY0111 - Ashley",
  "NZ - ATI0111 - Atiamuri",
  "NZ - ATI2201 - Atiamuri",
  "NZ - ATU1101 - Atarau",
  "NZ - AVI2201 - Aviemore",
  "NZ - BAL0331 - Balclutha",
  "NZ - BDE0111 - Brydone",
  "NZ - BEN0161 - Benmore",
  "NZ - BEN0162 - Benmore",
  "NZ - BEN0163 - Benmore",
  "NZ - BEN2202 - Benmore",
  "NZ - BLN0331 - Blenheim",
  "NZ - BOB0331 - Bombay",
  "NZ - BOB1101 - Bombay",
  "NZ - BPD1101 - Bells Pond",
  "NZ - BPE0331 - Bunnythorpe",
  "NZ - BPE0551 - Bunnythorpe",
  "NZ - BPE2201 - Bunnythorpe",
  "NZ - BPT1101 - Black Point",
  "NZ - BRB0331 - Bream Bay",
  "NZ - BRK0331 - Brunswick",
  "NZ - BRY0111 - Bromley",
  "NZ - BRY0661 - Bromley",
  "NZ - BWK1101 - Berwick",
  "NZ - BWR0111 - Blackwater",
  "NZ - CBE0331 - Cairnbrae",
  "NZ - CBG0111 - Cambridge",
  "NZ - CLH0111 - Castle Hill",
  "NZ - CML0331 - Cromwell",
  "NZ - COB0661 - Cobb",
  "NZ - COL0111 - Coleridge",
  "NZ - COL0661 - Coleridge",
  "NZ - CPK0111 - Central Park",
  "NZ - CPK0331 - Central Park",
  "NZ - CST0111 - Carrington Street",
  "NZ - CST0331 - Carrington Street",
  "NZ - CUL0331 - Culverden",
  "NZ - CUL0661 - Culverden",
  "NZ - CYD0331 - Clyde",
  "NZ - CYD2201 - Clyde",
  "NZ - DAR0111 - Dargaville",
  "NZ - DOB0331 - Dobson",
  "NZ - DOB0661 - Dobson",
  "NZ - DVK0111 - Dannevirke",
  "NZ - EDG0331 - Edgecumbe",
  "NZ - EDN0331 - Edendale",
  "NZ - FHL0331 - Fernhill",
  "NZ - FKN0331 - Frankton, Queenstown",
  "NZ - GFD0331 - Gracefield",
  "NZ - GIS0111 - Gisborne",
  "NZ - GIS0501 - Gisborne",
  "NZ - GLN0331 - Glenbrook",
  "NZ - GLN0332 - Glenbrook",
  "NZ - GOR0331 - Gore",
  "NZ - GYM0661 - Greymouth",
  "NZ - GYT0331 - Greytown",
  "NZ - HAM0111 - Hamilton",
  "NZ - HAM0331 - Hamilton",
  "NZ - HAM0551 - Hamilton",
  "NZ - HAM2201 - Hamilton",
  "NZ - HAY0111 - Haywards",
  "NZ - HAY0331 - Haywards",
  "NZ - HAY1101 - Haywards",
  "NZ - HBK0661 - Highbank",
  "NZ - HEN0331 - Henderson",
  "NZ - HEN2201 - Henderson",
  "NZ - HEP0331 - Hepburn Road",
  "NZ - HIN0331 - Hinuera",
  "NZ - HKK0661 - Hokitika",
  "NZ - HLY0331 - Huntly",
  "NZ - HLY2201 - Huntly",
  "NZ - HOB1101 - Hobson Street",
  "NZ - HOR0331 - Hororata",
  "NZ - HOR0661 - Hororata",
  "NZ - HRP2201 - Harapaki",
  "NZ - HTI0331 - Hangatiki",
  "NZ - HTI1101 - Hangatiki",
  "NZ - HUI0331 - Huirangi",
  "NZ - HWA0331 - Hawera",
  "NZ - HWA0332 - Hawera",
  "NZ - HWA1101 - Hawera",
  "NZ - HWA1102 - Hawera",
  "NZ - HWB0331 - Halfway Bush",
  "NZ - HWB0332 - Halfway Bush",
  "NZ - HWB1101 - Halfway Bush",
  "NZ - HWB2201 - Halfway Bush",
  "NZ - INV0331 - Invercargill",
  "NZ - INV2202 - Invercargill",
  "NZ - ISL0331 - Islington",
  "NZ - ISL0661 - Islington",
  "NZ - JRD1101 - Junction Road",
  "NZ - KAI0111 - Kaiapoi",
  "NZ - KAW0111 - Kawerau",
  "NZ - KAW0112 - Kawerau",
  "NZ - KAW0113 - Kawerau",
  "NZ - KAW1101 - Kawerau",
  "NZ - KAW2201 - Kawerau",
  "NZ - KBY0661 - Kimberly",
  "NZ - KBY0662 - Kimberly",
  "NZ - KEN0331 - Kensington",
  "NZ - KIK0111 - Kikiwa",
  "NZ - KIN0111 - Kinleith",
  "NZ - KIN0112 - Kinleith",
  "NZ - KIN0113 - Kinleith",
  "NZ - KIN0331 - Kinleith",
  "NZ - KKA0331 - Kaikoura",
  "NZ - KMO0331 - Kaitimako",
  "NZ - KOE0331 - Kaikohe",
  "NZ - KOE1101 - Kaikohe",
  "NZ - KPA1101 - Kaponga",
  "NZ - KPO1101 - Karapiro",
  "NZ - KPU0661 - Kopu",
  "NZ - KTA0331 - Kaitaia",
  "NZ - KUM0661 - Kumara",
  "NZ - KWA0111 - Kaiwharawhara",
  "NZ - LFD1101 - Lichfield",
  "NZ - LFD1102 - Lichfield",
  "NZ - LTN0331 - Linton",
  "NZ - LTN2201 - Linton",
  "NZ - MAN2201 - Manapouri",
  "NZ - MAT1101 - Matahina",
  "NZ - MAT1102 - Matahina",
  "NZ - MCH0111 - Murchison",
  "NZ - MDN0141 - Marsden",
  "NZ - MDN0142 - Marsden",
  "NZ - MDN0331 - Marsden",
  "NZ - MDN1101 - Marsden",
  "NZ - MDN2201 - Marsden",
  "NZ - MER0331 - Mokai",
  "NZ - MER1101 - Mokai",
  "NZ - MGM0331 - Mangamaire",
  "NZ - MHO0331 - Mangahao",
  "NZ - MKE1101 - McKee",
  "NZ - MLG0111 - Melling",
  "NZ - MLG0331 - Melling",
  "NZ - MLN0661 - Middleton",
  "NZ - MLN0664 - Middleton",
  "NZ - MNG0331 - Mangere",
  "NZ - MNG1101 - Mangere",
  "NZ - MNI0111 - Motunui",
  "NZ - MNO0111 - Mangaonoho",
  "NZ - MOT0111 - Motueka",
  "NZ - MPE0331 - Maungatapere",
  "NZ - MPE1101 - Maungatapere",
  "NZ - MPI0331 - Motupipi",
  "NZ - MPI0661 - Motupipi",
  "NZ - MRA0111 - Moturoa",
  "NZ - MRR0111 - Marotiri",
  "NZ - MST0331 - Masterton",
  "NZ - MTI0111 - Maraetai",
  "NZ - MTI2201 - Maraetai",
  "NZ - MTM0111 - Mount Maunganui",
  "NZ - MTM0331 - Mount Maunganui",
  "NZ - MTN0331 - Marton",
  "NZ - MTO0331 - Maungaturoto",
  "NZ - MTR0331 - Mataroa",
  "NZ - NAP2201 - Nga Awa Purua",
  "NZ - NAP2202 - Nga Awa Purua",
  "NZ - NMA0331 - North Makarewa",
  "NZ - NPK0331 - National Park",
  "NZ - NPL0331 - New Plymouth",
  "NZ - NPL1101 - New Plymouth",
  "NZ - NPL2201 - New Plymouth",
  "NZ - NSY0331 - Naseby",
  "NZ - NWD0661 - Norwood",
  "NZ - OAM0331 - Oamaru",
  "NZ - OHA2201 - Ohau A",
  "NZ - OHB2201 - Ohau B",
  "NZ - OHC2201 - Ohau C",
  "NZ - OHK2201 - Ohakuri",
  "NZ - OKI0111 - Ohaaki",
  "NZ - OKI2201 - Ohaaki",
  "NZ - OKN0111 - Ohakune",
  "NZ - ONG0331 - Ongarue",
  "NZ - OPK0331 - Opunake",
  "NZ - ORO1101 - Orowaiti Tee",
  "NZ - ORO1102 - Orowaiti Tee",
  "NZ - OTA0221 - Otahuhu",
  "NZ - OTA1101 - Otahuhu",
  "NZ - OTA1102 - Otahuhu",
  "NZ - OTA2202 - Otahuhu",
  "NZ - OTI0111 - Otira",
  "NZ - OWH0111 - Owhata",
  "NZ - PAK0331 - Pakuranga",
  "NZ - PAL0331 - Palmerston",
  "NZ - PAO1101 - Piako Zone Substation",
  "NZ - PAP0111 - Papanui",
  "NZ - PAP0661 - Papanui",
  "NZ - PEN0221 - Penrose",
  "NZ - PEN0251 - Penrose",
  "NZ - PEN0331 - Penrose",
  "NZ - PEN1101 - Penrose",
  "NZ - PNI0331 - Pauatahanui",
  "NZ - PPI2201 - Poihipi",
  "NZ - PRM0331 - Paraparaumu",
  "NZ - RDF0331 - Redclyffe",
  "NZ - RFN1101 - Reefton",
  "NZ - RFN1102 - Reefton",
  "NZ - RFT0111 - Reefton",
  "NZ - ROB1101 - Robertson Street",
  "NZ - ROS0221 - Mount Roskill",
  "NZ - ROS1101 - Mount Roskill",
  "NZ - ROT0111 - Rotorua",
  "NZ - ROT0331 - Rotorua",
  "NZ - ROT1101 - Rotorua",
  "NZ - ROX1101 - Roxburgh",
  "NZ - ROX2201 - Roxburgh",
  "NZ - RPO2201 - Rangipo",
  "NZ - SBK0331 - Southbrook",
  "NZ - SBK0661 - Southbrook",
  "NZ - SDN0331 - South Dunedin",
  "NZ - SFD0331 - Stratford",
  "NZ - SPN0331 - Springston",
  "NZ - SPN0661 - Springston",
  "NZ - STK0331 - Stoke",
  "NZ - STK0661 - Stoke",
  "NZ - STK2201 - Stoke",
  "NZ - STU0111 - Studholme",
  "NZ - SVL0331 - Silverdale",
  "NZ - SWN0251 - Southdown",
  "NZ - SWN2201 - Southdown",
  "NZ - TAB0331 - Tauhara",
  "NZ - TAB2201 - Tauhara",
  "NZ - TAK0331 - Takanini",
  "NZ - TGA0111 - Tauranga",
  "NZ - TGA0331 - Tauranga",
  "NZ - THI2201 - Te Mihi",
  "NZ - TIM0111 - Timaru",
  "NZ - TKA0111 - Tekapo A",
  "NZ - TKA0331 - Tekapo A",
  "NZ - TKB2201 - Tekapo B",
  "NZ - TKH0111 - Te Kaha",
  "NZ - TKR0331 - Takapu Road",
  "NZ - TKU0331 - Tokaanu",
  "NZ - TKU2201 - Tokaanu",
  "NZ - TMI0331 - Te Matai",
  "NZ - TMK0111 - Temuka",
  "NZ - TMK0331 - Temuka",
  "NZ - TMN0551 - Taumarunui",
  "NZ - TMU0111 - Te Awamutu",
  "NZ - TMU1101 - Te Awamutu",
  "NZ - TNG0111 - Tangiwai",
  "NZ - TNG0551 - Tangiwai",
  "NZ - TOB0501 - Tokomaru Bay",
  "NZ - TRK0111 - Tarukenga",
  "NZ - TRK2201 - Tarukenga",
  "NZ - TUI0111 - Tuai",
  "NZ - TUI1101 - Tuai",
  "NZ - TWC2201 - Tararua Wind Central",
  "NZ - TWH0331 - Te Kowhai",
  "NZ - TWI2201 - Tiwai",
  "NZ - TWZ0331 - Twizel",
  "NZ - UHT0331 - Upper Hutt",
  "NZ - WAI0111 - Waiotahi",
  "NZ - WAI0331 - Waiotahi",
  "NZ - WAI0501 - Waiotahi",
  "NZ - WDV0111 - Woodville",
  "NZ - WDV1101 - Woodville",
  "NZ - WEL0331 - Wellsford",
  "NZ - WES0331 - Western Road",
  "NZ - WGN0331 - Wanganui",
  "NZ - WHI0111 - Whirinaki",
  "NZ - WHI2201 - Whirinaki",
  "NZ - WHU0331 - Waihou",
  "NZ - WIL0331 - Wilton",
  "NZ - WIR0331 - Wiri",
  "NZ - WKO0331 - Waikino",
  "NZ - WMG0331 - Waimangaroa",
  "NZ - WPA2201 - Waipapa",
  "NZ - WPR0331 - Waipara",
  "NZ - WPR0661 - Waipara",
  "NZ - WPT0111 - Westport",
  "NZ - WPW0331 - Waipawa",
  "NZ - WRA0111 - Wairoa",
  "NZ - WRA0501 - Wairoa",
  "NZ - WRD0331 - Wairau Road",
  "NZ - WRK0331 - Wairakei",
  "NZ - WRK2201 - Wairakei",
  "NZ - WTK0111 - Waitaki",
  "NZ - WTK0331 - Waitaki",
  "NZ - WTK2201 - Waitaki",
  "NZ - WTN0111 - Winton",
  "NZ - WTN0661 - Winton",
  "NZ - WTU0331 - Whakatu",
  "NZ - WVY0111 - Waverley",
  "NZ - WVY1101 - Waverley",
  "NZ - WWD1102 - West Wind",
  "NZ - WWD1103 - West Wind",
  "WVY110",
];

export const TechnologyList = [
  "PV (fixed)",
  "Wind (onshore)",
  "Battery",
  "Mix PV (fixed) & Wind (onshore)",
  "Mix PV (Fixed) & Battery",
  "Hydro",
];

export const PPAVolumeStructureList = ["Pay as produced", "Baseload"];

export const PPAVolumeCapacityUnit = ["MW", "MWh/yr"];

export const PPAPricingList = ["Fix", "Indexed with CPI", "Custom"];

export const DegradationList = ["0.5 %", "0.25 %", "Custom fixed"];

export const DiscountingFactorList = ["Risk free rate", "Custom fixed"];

export const ChangingVolumeList = ["Yes", "No"];

export const UseBenchMarkList = ["Yes", "No"];

export const PowerPriceCurveList = ["Yes", "No"];

export const GOOPriceCurveList = ["Yes", "No"];

export const CarbonIntensityOfGridList = ["Yes", "No"];

export const PPAYearList = [
  "2025",
  "2026",
  "2027",
  "2028",
  "2029",
  "2030",
  "2031",
  "2032",
  "2033",
  "2034",
  "2035",
  "2036",
  "2037",
  "2038",
  "2039",
  "2040",
  "2041",
  "2042",
  "2043",
  "2044",
  "2045",
  "2046",
  "2047",
  "2048",
  "2049",
  "2050",
  "2051",
  "2052",
  "2053",
  "2054",
  "2055",
  "2056",
  "2057",
  "2058",
  "2059",
  "2060",
  "2061",
  "2062",
  "2063",
  "2064",
  "2065",
  "2066",
  "2067",
  "2068",
  "2069",
  "2070",
  "2071",
  "2072",
  "2073",
  "2074",
  "2075",
  "2076",
  "2077",
  "2078",
  "2079",
  "2080",
];

export const PPASenarioList = ["Medium", "Low", "High"];

export const CountryLocationList = [
  "Australia New South Wales",
  "Australia Queensland",
  "Australia Tasmania",
  "Australia Victoria",
  "Australia Western Australia",
  "Brazil Central-West",
  "Brazil North",
  "Brazil Northeast",
  "Brazil South",
  "Brazil Southeast",
  "Finland",
  "France",
  "Germany",
  "India Eastern Region",
  "India Northeastern Region",
  "India Northern Region",
  "India Southern Region",
  "India Western Region",
  "Italy C.North",
  "Italy C. South",
  "Italy Calabria",
  "Italy North",
  "Italy Sardinia",
  "Italy Sicily",
  "Italy South",
  "Netherlands",
  "New Zealand - North",
  "New Zealand - South",
  "Poland",
  "Portugal",
  "Romania",
  "Singapore",
  "Spain",
  "Sweden 1",
  "Sweden 2",
  "Sweden 3",
  "Sweden 4",
  "Turkey",
  "U.S. CAISO",
  "U.S. ERCOT",
  "U.S. ISO-NE",
  "U.S. MISO",
  "U.S. Northwest",
  "U.S. NYISO",
  "U.S. PJM",
  "U.S. Southeast",
  "U.S. Southwest",
  "U.S. SPP",
  "United Kingdom",
  "NZ - OTA2201 - Otahuhu",
  "NZ - WKM2201 - Whakamaru",
  "NZ - RDF2201 - Redclyffe",
  "NZ - SFD2201 - Stratford",
  "NZ - HAY2201 - Haywards",
  "NZ - KIK2201 - Kikiwa",
  "NZ - ISL2201 - Islington",
  "NZ - BEN2201 - Benmore",
  "NZ - INV2201 - Invercargill",
  "NZ - ABY0111 - Albury",
  "NZ - ADD0111 - Addington",
  "NZ - ADD0661 - Addington",
  "NZ - AHA0111 - Arahura",
  "NZ - ALB0331 - Albany",
  "NZ - ALB1101 - Albany",
  "NZ - ANA0111 - Arohena",
  "NZ - APS0111 - Arthur's Pass",
  "NZ - ARA2201 - Aratiatia",
  "NZ - ARG1101 - Argyle",
  "NZ - ARI0501 - Arapuni",
  "NZ - ARI1101 - Arapuni",
  "NZ - ARI1102 - Arapuni",
  "NZ - ASB0331 - Ashburton",
  "NZ - ASB0661 - Ashburton",
  "NZ - ASY0111 - Ashley",
  "NZ - ATI0111 - Atiamuri",
  "NZ - ATI2201 - Atiamuri",
  "NZ - ATU1101 - Atarau",
  "NZ - AVI2201 - Aviemore",
  "NZ - BAL0331 - Balclutha",
  "NZ - BDE0111 - Brydone",
  "NZ - BEN0161 - Benmore",
  "NZ - BEN0162 - Benmore",
  "NZ - BEN0163 - Benmore",
  "NZ - BEN2202 - Benmore",
  "NZ - BLN0331 - Blenheim",
  "NZ - BOB0331 - Bombay",
  "NZ - BOB1101 - Bombay",
  "NZ - BPD1101 - Bells Pond",
  "NZ - BPE0331 - Bunnythorpe",
  "NZ - BPE0551 - Bunnythorpe",
  "NZ - BPE2201 - Bunnythorpe",
  "NZ - BPT1101 - Black Point",
  "NZ - BRB0331 - Bream Bay",
  "NZ - BRK0331 - Brunswick",
  "NZ - BRY0111 - Bromley",
  "NZ - BRY0661 - Bromley",
  "NZ - BWK1101 - Berwick",
  "NZ - BWR0111 - Blackwater",
  "NZ - CBE0331 - Cairnbrae",
  "NZ - CBG0111 - Cambridge",
  "NZ - CLH0111 - Castle Hill",
  "NZ - CML0331 - Cromwell",
  "NZ - COB0661 - Cobb",
  "NZ - COL0111 - Coleridge",
  "NZ - COL0661 - Coleridge",
  "NZ - CPK0111 - Central Park",
  "NZ - CPK0331 - Central Park",
  "NZ - CST0111 - Carrington Street",
  "NZ - CST0331 - Carrington Street",
  "NZ - CUL0331 - Culverden",
  "NZ - CUL0661 - Culverden",
  "NZ - CYD0331 - Clyde",
  "NZ - CYD2201 - Clyde",
  "NZ - DAR0111 - Dargaville",
  "NZ - DOB0331 - Dobson",
  "NZ - DOB0661 - Dobson",
  "NZ - DVK0111 - Dannevirke",
  "NZ - EDG0331 - Edgecumbe",
  "NZ - EDN0331 - Edendale",
  "NZ - FHL0331 - Fernhill",
  "NZ - FKN0331 - Frankton, Queenstown",
  "NZ - GFD0331 - Gracefield",
  "NZ - GIS0111 - Gisborne",
  "NZ - GIS0501 - Gisborne",
  "NZ - GLN0331 - Glenbrook",
  "NZ - GLN0332 - Glenbrook",
  "NZ - GOR0331 - Gore",
  "NZ - GYM0661 - Greymouth",
  "NZ - GYT0331 - Greytown",
  "NZ - HAM0111 - Hamilton",
  "NZ - HAM0331 - Hamilton",
  "NZ - HAM0551 - Hamilton",
  "NZ - HAM2201 - Hamilton",
  "NZ - HAY0111 - Haywards",
  "NZ - HAY0331 - Haywards",
  "NZ - HAY1101 - Haywards",
  "NZ - HBK0661 - Highbank",
  "NZ - HEN0331 - Henderson",
  "NZ - HEN2201 - Henderson",
  "NZ - HEP0331 - Hepburn Road",
  "NZ - HIN0331 - Hinuera",
  "NZ - HKK0661 - Hokitika",
  "NZ - HLY0331 - Huntly",
  "NZ - HLY2201 - Huntly",
  "NZ - HOB1101 - Hobson Street",
  "NZ - HOR0331 - Hororata",
  "NZ - HOR0661 - Hororata",
  "NZ - HRP2201 - Harapaki",
  "NZ - HTI0331 - Hangatiki",
  "NZ - HTI1101 - Hangatiki",
  "NZ - HUI0331 - Huirangi",
  "NZ - HWA0331 - Hawera",
  "NZ - HWA0332 - Hawera",
  "NZ - HWA1101 - Hawera",
  "NZ - HWA1102 - Hawera",
  "NZ - HWB0331 - Halfway Bush",
  "NZ - HWB0332 - Halfway Bush",
  "NZ - HWB1101 - Halfway Bush",
  "NZ - HWB2201 - Halfway Bush",
  "NZ - INV0331 - Invercargill",
  "NZ - INV2202 - Invercargill",
  "NZ - ISL0331 - Islington",
  "NZ - ISL0661 - Islington",
  "NZ - JRD1101 - Junction Road",
  "NZ - KAI0111 - Kaiapoi",
  "NZ - KAW0111 - Kawerau",
  "NZ - KAW0112 - Kawerau",
  "NZ - KAW0113 - Kawerau",
  "NZ - KAW1101 - Kawerau",
  "NZ - KAW2201 - Kawerau",
  "NZ - KBY0661 - Kimberly",
  "NZ - KBY0662 - Kimberly",
  "NZ - KEN0331 - Kensington",
  "NZ - KIK0111 - Kikiwa",
  "NZ - KIN0111 - Kinleith",
  "NZ - KIN0112 - Kinleith",
  "NZ - KIN0113 - Kinleith",
  "NZ - KIN0331 - Kinleith",
  "NZ - KKA0331 - Kaikoura",
  "NZ - KMO0331 - Kaitimako",
  "NZ - KOE0331 - Kaikohe",
  "NZ - KOE1101 - Kaikohe",
  "NZ - KPA1101 - Kaponga",
  "NZ - KPO1101 - Karapiro",
  "NZ - KPU0661 - Kopu",
  "NZ - KTA0331 - Kaitaia",
  "NZ - KUM0661 - Kumara",
  "NZ - KWA0111 - Kaiwharawhara",
  "NZ - LFD1101 - Lichfield",
  "NZ - LFD1102 - Lichfield",
  "NZ - LTN0331 - Linton",
  "NZ - LTN2201 - Linton",
  "NZ - MAN2201 - Manapouri",
  "NZ - MAT1101 - Matahina",
  "NZ - MAT1102 - Matahina",
  "NZ - MCH0111 - Murchison",
  "NZ - MDN0141 - Marsden",
  "NZ - MDN0142 - Marsden",
  "NZ - MDN0331 - Marsden",
  "NZ - MDN1101 - Marsden",
  "NZ - MDN2201 - Marsden",
  "NZ - MER0331 - Mokai",
  "NZ - MER1101 - Mokai",
  "NZ - MGM0331 - Mangamaire",
  "NZ - MHO0331 - Mangahao",
  "NZ - MKE1101 - McKee",
  "NZ - MLG0111 - Melling",
  "NZ - MLG0331 - Melling",
  "NZ - MLN0661 - Middleton",
  "NZ - MLN0664 - Middleton",
  "NZ - MNG0331 - Mangere",
  "NZ - MNG1101 - Mangere",
  "NZ - MNI0111 - Motunui",
  "NZ - MNO0111 - Mangaonoho",
  "NZ - MOT0111 - Motueka",
  "NZ - MPE0331 - Maungatapere",
  "NZ - MPE1101 - Maungatapere",
  "NZ - MPI0331 - Motupipi",
  "NZ - MPI0661 - Motupipi",
  "NZ - MRA0111 - Moturoa",
  "NZ - MRR0111 - Marotiri",
  "NZ - MST0331 - Masterton",
  "NZ - MTI0111 - Maraetai",
  "NZ - MTI2201 - Maraetai",
  "NZ - MTM0111 - Mount Maunganui",
  "NZ - MTM0331 - Mount Maunganui",
  "NZ - MTN0331 - Marton",
  "NZ - MTO0331 - Maungaturoto",
  "NZ - MTR0331 - Mataroa",
  "NZ - NAP2201 - Nga Awa Purua",
  "NZ - NAP2202 - Nga Awa Purua",
  "NZ - NMA0331 - North Makarewa",
  "NZ - NPK0331 - National Park",
  "NZ - NPL0331 - New Plymouth",
  "NZ - NPL1101 - New Plymouth",
  "NZ - NPL2201 - New Plymouth",
  "NZ - NSY0331 - Naseby",
  "NZ - NWD0661 - Norwood",
  "NZ - OAM0331 - Oamaru",
  "NZ - OHA2201 - Ohau A",
  "NZ - OHB2201 - Ohau B",
  "NZ - OHC2201 - Ohau C",
  "NZ - OHK2201 - Ohakuri",
  "NZ - OKI0111 - Ohaaki",
  "NZ - OKI2201 - Ohaaki",
  "NZ - OKN0111 - Ohakune",
  "NZ - ONG0331 - Ongarue",
  "NZ - OPK0331 - Opunake",
  "NZ - ORO1101 - Orowaiti Tee",
  "NZ - ORO1102 - Orowaiti Tee",
  "NZ - OTA0221 - Otahuhu",
  "NZ - OTA1101 - Otahuhu",
  "NZ - OTA1102 - Otahuhu",
  "NZ - OTA2202 - Otahuhu",
  "NZ - OTI0111 - Otira",
  "NZ - OWH0111 - Owhata",
  "NZ - PAK0331 - Pakuranga",
  "NZ - PAL0331 - Palmerston",
  "NZ - PAO1101 - Piako Zone Substation",
  "NZ - PAP0111 - Papanui",
  "NZ - PAP0661 - Papanui",
  "NZ - PEN0221 - Penrose",
  "NZ - PEN0251 - Penrose",
  "NZ - PEN0331 - Penrose",
  "NZ - PEN1101 - Penrose",
  "NZ - PNI0331 - Pauatahanui",
  "NZ - PPI2201 - Poihipi",
  "NZ - PRM0331 - Paraparaumu",
  "NZ - RDF0331 - Redclyffe",
  "NZ - RFN1101 - Reefton",
  "NZ - RFN1102 - Reefton",
  "NZ - RFT0111 - Reefton",
  "NZ - ROB1101 - Robertson Street",
  "NZ - ROS0221 - Mount Roskill",
  "NZ - ROS1101 - Mount Roskill",
  "NZ - ROT0111 - Rotorua",
  "NZ - ROT0331 - Rotorua",
  "NZ - ROT1101 - Rotorua",
  "NZ - ROX1101 - Roxburgh",
  "NZ - ROX2201 - Roxburgh",
  "NZ - RPO2201 - Rangipo",
  "NZ - SBK0331 - Southbrook",
  "NZ - SBK0661 - Southbrook",
  "NZ - SDN0331 - South Dunedin",
  "NZ - SFD0331 - Stratford",
  "NZ - SPN0331 - Springston",
  "NZ - SPN0661 - Springston",
  "NZ - STK0331 - Stoke",
  "NZ - STK0661 - Stoke",
  "NZ - STK2201 - Stoke",
  "NZ - STU0111 - Studholme",
  "NZ - SVL0331 - Silverdale",
  "NZ - SWN0251 - Southdown",
  "NZ - SWN2201 - Southdown",
  "NZ - TAB0331 - Tauhara",
  "NZ - TAB2201 - Tauhara",
  "NZ - TAK0331 - Takanini",
  "NZ - TGA0111 - Tauranga",
  "NZ - TGA0331 - Tauranga",
  "NZ - THI2201 - Te Mihi",
  "NZ - TIM0111 - Timaru",
  "NZ - TKA0111 - Tekapo A",
  "NZ - TKA0331 - Tekapo A",
  "NZ - TKB2201 - Tekapo B",
  "NZ - TKH0111 - Te Kaha",
  "NZ - TKR0331 - Takapu Road",
  "NZ - TKU0331 - Tokaanu",
  "NZ - TKU2201 - Tokaanu",
  "NZ - TMI0331 - Te Matai",
  "NZ - TMK0111 - Temuka",
  "NZ - TMK0331 - Temuka",
  "NZ - TMN0551 - Taumarunui",
  "NZ - TMU0111 - Te Awamutu",
  "NZ - TMU1101 - Te Awamutu",
  "NZ - TNG0111 - Tangiwai",
  "NZ - TNG0551 - Tangiwai",
  "NZ - TOB0501 - Tokomaru Bay",
  "NZ - TRK0111 - Tarukenga",
  "NZ - TRK2201 - Tarukenga",
  "NZ - TUI0111 - Tuai",
  "NZ - TUI1101 - Tuai",
  "NZ - TWC2201 - Tararua Wind Central",
  "NZ - TWH0331 - Te Kowhai",
  "NZ - TWI2201 - Tiwai",
  "NZ - TWZ0331 - Twizel",
  "NZ - UHT0331 - Upper Hutt",
  "NZ - WAI0111 - Waiotahi",
  "NZ - WAI0331 - Waiotahi",
  "NZ - WAI0501 - Waiotahi",
  "NZ - WDV0111 - Woodville",
  "NZ - WDV1101 - Woodville",
  "NZ - WEL0331 - Wellsford",
  "NZ - WES0331 - Western Road",
  "NZ - WGN0331 - Wanganui",
  "NZ - WHI0111 - Whirinaki",
  "NZ - WHI2201 - Whirinaki",
  "NZ - WHU0331 - Waihou",
  "NZ - WIL0331 - Wilton",
  "NZ - WIR0331 - Wiri",
  "NZ - WKO0331 - Waikino",
  "NZ - WMG0331 - Waimangaroa",
  "NZ - WPA2201 - Waipapa",
  "NZ - WPR0331 - Waipara",
  "NZ - WPR0661 - Waipara",
  "NZ - WPT0111 - Westport",
  "NZ - WPW0331 - Waipawa",
  "NZ - WRA0111 - Wairoa",
  "NZ - WRA0501 - Wairoa",
  "NZ - WRD0331 - Wairau Road",
  "NZ - WRK0331 - Wairakei",
  "NZ - WRK2201 - Wairakei",
  "NZ - WTK0111 - Waitaki",
  "NZ - WTK0331 - Waitaki",
  "NZ - WTK2201 - Waitaki",
  "NZ - WTN0111 - Winton",
  "NZ - WTN0661 - Winton",
  "NZ - WTU0331 - Whakatu",
  "NZ - WVY0111 - Waverley",
  "NZ - WVY1101 - Waverley",
  "NZ - WWD1102 - West Wind",
  "NZ - WWD1103 - West Wind",
  "WVY110",
];

export const CountryCurrencyList = [
  { country: "Australia New South Wales", currency: "AUD" },
  { country: "Australia Queensland", currency: "AUD" },
  { country: "Australia Tasmania", currency: "AUD" },
  { country: "Australia Victoria", currency: "AUD" },
  { country: "Australia Western Australia", currency: "AUD" },
  { country: "Brazil Central-West", currency: "BRL" },
  { country: "Brazil North", currency: "BRL" },
  { country: "Brazil Northeast", currency: "BRL" },
  { country: "Brazil South", currency: "BRL" },
  { country: "Brazil Southeast", currency: "BRL" },
  { country: "Finland", currency: "EUR" },
  { country: "France", currency: "EUR" },
  { country: "Germany", currency: "EUR" },
  { country: "India Eastern Region", currency: "INR" },
  { country: "India Northeastern Region", currency: "INR" },
  { country: "India Northern Region", currency: "INR" },
  { country: "India Southern Region", currency: "INR" },
  { country: "India Western Region", currency: "INR" },
  { country: "Italy C.North", currency: "EUR" },
  { country: "Italy C. South", currency: "EUR" },
  { country: "Italy Calabria", currency: "EUR" },
  { country: "Italy North", currency: "EUR" },
  { country: "Italy Sardinia", currency: "EUR" },
  { country: "Italy Sicily", currency: "EUR" },
  { country: "Italy South", currency: "EUR" },
  { country: "Netherlands", currency: "EUR" },
  { country: "New Zealand - North", currency: "NZD" },
  { country: "New Zealand - South", currency: "NZD" },
  { country: "Poland", currency: "PLN" },
  { country: "Portugal", currency: "EUR" },
  { country: "Romania", currency: "RON" },
  { country: "Singapore", currency: "SGD" },
  { country: "Spain", currency: "EUR" },
  { country: "Sweden 1", currency: "SEK" },
  { country: "Sweden 2", currency: "SEK" },
  { country: "Sweden 3", currency: "SEK" },
  { country: "Sweden 4", currency: "SEK" },
  { country: "Turkey", currency: "TRY" },
  { country: "U.S. CAISO", currency: "USD" },
  { country: "U.S. ERCOT", currency: "USD" },
  { country: "U.S. ISO-NE", currency: "USD" },
  { country: "U.S. MISO", currency: "USD" },
  { country: "U.S. Northwest", currency: "USD" },
  { country: "U.S. NYISO", currency: "USD" },
  { country: "U.S. PJM", currency: "USD" },
  { country: "U.S. Southeast", currency: "USD" },
  { country: "U.S. Southwest", currency: "USD" },
  { country: "U.S. SPP", currency: "USD" },
  { country: "United Kingdom", currency: "GBP" },
  { country: "NZ - OTA2201 - Otahuhu", currency: "NZD" },
  { country: "WVY110", currency: "NZD" },
];

export const yesOrNoList = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export const valuationPerspectiveList = [
  { label: "Buyer", value: "buyer" },
  { label: "Seller", value: "seller" },
];

export const valuationClientTypeList = [
  { label: "Channel 1", value: "channel_1" },
  { label: "Channel 2", value: "channel_2" },
];

export const modelTypes = [
  {
    label: "Market Sounding - Strategy Phase",
    value: "new_PPA",
    disabled: false,
  },
  {
    label: "Mark-To-Market - PPA Valuation",
    value: "existing_PPA",
    disabled: false,
  },
  {
    label: "Risk Adjusted Return",
    value: "risk_adjusted_return",
    disabled: true,
  },
  { label: "Monte Carlo Simulation", value: "monte_carlo", disabled: true },
  {
    label: "PPA Options- Contract Extension",
    value: "options_contract_extension",
    disabled: true,
  },
  {
    label: "PPA Options- Early Termination",
    value: "options_early_termination",
    disabled: true,
  },
  { label: "Energy Modelling", value: "energy_modelling", disabled: true },
];

export const existingPPACurveTypes = [
  { label: "Black Market Price Curve", value: "blackMarketPriceCurve" },
  { label: "Green Market Price Curve", value: "greenMarketPriceCurve" },
  { label: "MLF Curve", value: "mlfCurve" },
  { label: "DLF Curve", value: "dlfCurve" },
  { label: "Curtailment Factor", value: "curtailmentFactor" },
  { label: "Inflation Curve", value: "inflationCurve" },
  { label: "CPI Curve", value: "cpiCurve" },
  { label: "RiskFree Rate Curve", value: "riskFreeRateCurve" },
  {
    label: "Asset Credit Risk Adjustment Curve",
    value: "assetCreditRiskAdjustmentCurve",
  },
  {
    label: "Liability Credit Risk Adjustment Curve",
    value: "liabilityCreditRiskAdjustmentCurve",
  },
];

export const ValuationFreequencyOptions = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Yearly", value: "yearly" },
];

export const TechnologyOptions = [
  { label: "PV (fixed)", value: "pv_fixed" },
  { label: "Wind (onshore)", value: "wind_onshore" },
  { label: "Mix PV (fixed) & Wind (onshore)", value: "mix_pv_wind" },
  { label: "Hydro", value: "hydro" },
  { label: "Battery", value: "battery" },
];

export const PPAPricingOptions = [
  { label: "Fixed", value: "fix" },
  { label: "Indexed with CPI", value: "indexed_with_cpi" },
  { label: "Custom", value: "custom" },
];

export const UnbundlingApproachList = [
  { label: "Flat Unbundling", value: "flat_unbundling" },
  { label: "Dynamic Unbundling", value: "dynamic_unbundling" },
  { label: "Annual Rolling", value: "annual_rolling" },
  { label: "No Unbundling", value: "no_unbundling" },
];

export const discountingApproachList = [
  { label: "Period-By-Period Approach", value: "period_by_period" },
  { label: "Net Approach", value: "net" },
];

export const discountingConventionList = [
  { label: "Mid-Period Discounting", value: "mid_period" },
  { label: "End-Of-Period Discounting", value: "end_period" },
];

export const basisOfCalibrationList = [
  { label: "$", value: "usd" },
  { label: "%", value: "percentage" },
];

export const GenerationTypeOptions = [
  { label: "Total Asset Generation", value: "total_asset_generation" },
  { label: "Proportional Generation", value: "proportional_generation" },
];

export const existingPPASenarioList = ["Medium", "EY", "Custom"];

export const COUNTRY_CERTIFICATE_MAPPER = {
  "united kingdom": "REGO",
  australia: "LGC/REC",
  spain: "GoO",
};

export const COUNTRY_CERTIFICATE_MAPPERS = {
  "united kingdom": "REGOs",
  australia: "LGCs/RECs",
  spain: "GoOs",
};
